import type React from 'react'
import type { GenericFormType } from '@neo/blocks/forms/types'
import { JsonKeyValueEditor } from './json-key-value-editor'
import type { StartNodeData } from '../types'

type ApiRequestVarsWrapperProps = {
  form: GenericFormType<StartNodeData['config']>
}

export const ApiRequestVarsWrapper: React.FC<ApiRequestVarsWrapperProps> = ({ form }) => {
  const payloadFormat =
    typeof form.state.values.payload_format === 'string'
      ? JSON.parse(form.state.values.payload_format)
      : form.state.values.payload_format || {}

  return (
    <JsonKeyValueEditor
      initialData={payloadFormat}
      apiRequestVars
      onChange={(newPayloadFormat) =>
        form.setFieldValue('payload_format', JSON.stringify(newPayloadFormat))
      }
    />
  )
}
